import utils from './index'
import config from '../config'
import ConfirmBox from '@/components/confirmBox'

import { ajax } from 'gkSrc/utils/request.js'

// 自定义 headers
let requestHeaders = {
  'Content-Type': 'application/json'
}

let deviceId = utils.getDeviceId()
let ticket = utils.getTicket()
if (deviceId && ticket) {
  requestHeaders['Device-Id'] = deviceId
  requestHeaders['Ticket'] = ticket
}

// 是否可使用跨域
let requestWithCredentials = true

export default function (options = {}) {
  options.withCredentials = options.withCredentials !== undefined ? options.withCredentials : requestWithCredentials
  options.headers = Object.assign({}, requestHeaders, options.headers)

  options.host = options.host || config.tgoServer

  return ajax(options).then(res => {
    return res
  }).catch(err => {
    // 需要登录的接口，未登录时自动跳转到登录页面
    try {
      if (err.api === 1) {
        // 需要登录的接口，在未登录时的错误
        if (err.code === -2000 || err.code === -1004 || err.code === -3050) {
          // 需要根据相关业务封装相关登录方法
          // utils.login()
        }
      } else {
        if (err.error.response.status === 452 || err.error.response.status === 451 || err.error.response.status === 401) {
          // 调用一下注销接口，删掉 GCESS
          let img = new Image()
          img.src = `//account.geekbang.org/account/ticket/delete`
          ConfirmBox({
            title: '下线通知',
            content: '该账号已在其他同类设备登录，如非本人操作，则密码可能已经泄露，建议立即更换密码',
            btnOk: '确定',
            okCallback: () => {
              // window.location.href = 'https://account.geekbang.org/sigin?redirect=' + window.encodeURIComponent(window.location.href)
            }
          })
        }
      }
    } catch (error) {
      console.log('ajax', options, error)
    }

    return Promise.reject(err)
  })
}
